import { useRouter } from 'next/router';
import Header from './header';
import Footer from './footer';

function Layout({ children } : any ) {
  const router = useRouter();
  
  const hideHeaderPaths = ['/nft', '/api-doc', '/docs'];
  const hideFooterPaths = ['/nft', '/api-doc', '/docs', '/'];

  const showHeader = !hideHeaderPaths.some(path => router.pathname.startsWith(path));
  const showFooter = !hideFooterPaths.some(path => router.pathname.startsWith(path));

  return (
    <>
        {showHeader && <Header/>}
        <main>{ children }</main>
        {showFooter && <Footer/>}
    </>
  )
}

export default Layout;
